import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthService } from '../shared/service/auth.service';
import { ApiService } from '../shared/service/api.service';
import { TokenService } from '../shared/service/token.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router,
    private apiService: ApiService,
    private tokenService: TokenService
  ) { }

  public async canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    if (!this.isBranchInLocalStorage()) {
      this.router.navigate(['/login']);
      return false;
    }

    var allow = await this.hasAccess(state);
    if (allow) {
      allow = await this.handlePageToken(next, state);
    }

    return allow;
  }

  private isBranchInLocalStorage(): boolean {
    return localStorage.getItem('branch') !== null;
  }

  private async hasAccess(state: RouterStateSnapshot): Promise<boolean> {
    return this.authService.validateUserHasAuthorization();
  }

  recoverMenu() {
    const menus = this.apiService.getMenuList();
    menus.subscribe((menus: any[]) => {
      this.tokenService.saveItem('menus', JSON.stringify(menus));
    });
    return menus;
  }

  handlePageToken(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.recoverMenu().subscribe({
        next: (menus: any[]) => {

          const currentLink = state.url.substring(1).split('?')[0].split('/')[0];
          let result: string | null = null;
          menus.forEach((item: any) => {
            if (!result) {
              result = this.findLinkInMenu(item, currentLink);
            }
          });

          if (next.data['checkMenu'] && !result) {
            this.router.navigate(['/access-denied']);
            resolve(false);
            return;
          }

          if (result) {
            this.generateComponentToken(result)
              .then(() => resolve(true))
              .catch(err => reject(err));
          } else {
            resolve(true);
          }
        },
        error: (err) => {
          console.error('Erro ao processar menu:', err);
          reject(err);
        }
      });
    });
  }



  private findLinkInMenu(item: any, currentLink: string): string | null {

    if (item.subItems?.length) {
      for (const sub of item.subItems) {
        if (sub.link === currentLink) {
          return currentLink;
        }
      }
    }

    return null;
  }

  private async generateComponentToken(componentName: string) {
    await new Promise<void>((resolve) => {
      this.apiService.postCustomerToken(this.tokenService.getComponentCode(componentName)!).subscribe((data: any) => {
        this.tokenService.saveComponentCodeToken(data.access_token);
        resolve();
      });
    });
  }
}
